import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";
import ImportLog from "../ImportLog";
import ImportData from "../ImportData";
import Button from "../2/Controls/Button";
import { countBy } from "lodash";
import { getCustomers } from "../../actions/CustomerAction";

class CustomerList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      importType: "",

      page: 1,
      pageSize: 25,

      searchParam: "",

      filter: {

        name: "",
        mobileNo: "",
        emailId: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        membership: "",
        status: "active",
        wallet:"",
        segment:""

      },

      showFilter: false,
      showOption: false,
      showImportLog: false,
      showImport: false,
      showDelete: false,

      selectedRow: null,

      isFilterActive: false,
      stores:[],

      listPageSettings: {

        Title: "Customers",

        Search: {

          showSearch: true,
          placeholder: "Search customer by name, mobile no or email id",

          onSearch: this.onSearch,

          onRefresh: this.onRefreshClick,

          onFilterClick: () =>
            this.setState({ showFilter: true }),

          isFilterActive: false

        },

        HeaderButtons: [

          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },

          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options"
          }

        ],

        Columns: [

          {
            Name: "Customer",
            Type: "multiple",
            ShowInMobile: true,
            Columns: [
              {
                Type: "concatenate",
                Columns: [
                  { Column: "FirstName" },
                  { Column: "LastName" }
                ],
              },
              { Column: "PhoneNo" },
              { Column: "EmailID" },
              { Label: "Amount Spent", Column: "AmountSpent" },
              { Label: "Visits", Column: "NoOfVisits" },
            ],
          },

          {
            Name: "Customer Details",
            Type: "multiple",
            Columns: [
              {
                Type: "concatenate",
                Columns: [
                  { Column: "FirstName" },
                  { Column: "LastName" }
                ],
              },
              { Column: "CustomerCode" },
              { Column: "Gender" },
            ],
          },

          {
            Name: "Contact Details",
            Type: "multiple",
            Columns: [
              { Column: "PhoneNo" },
              { Column: "EmailID" }
            ],
          },

          { Name: "Address", Type: "address" },

          {
            Name: "Additional Details",
            Type: "multiple",
            Columns: [

              { Label: "Amount Spent", Column: "AmountSpent" },

              { Label: "No Of Visits", Column: "NoOfVisits" },

              {
                Column: "LastVisitedOn",
                Label: "Last Visited",
                Type: "date"
              },

              {
                Column: "WalletLastCreditAmount",
                Label: "Last Recharge",
                Type: "number"
              },

              {
                Column: "WalletBalance",
                Label: "Wallet Balance",
                Type: "number"
              },

              {
                Column: "Membership.Name",
                Label: "Membership"
              },

            ],
          },

          {
            Name: "Notes",
            Type: "field",
            Columns: [{ Column: "Notes" }]
          },

        ],

        RowButtons: [

          {
            ButtonType: "ImageButton",
            Type: "view",
            Text: "View",
            Icon: "view"
          },

          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          },

          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete"
          }

        ]

      }

    };

  }

componentDidMount() {

  let stores = this.props.config.UserStores;

  let segment = "";
  let wallet = "";

  if (this.props.location && this.props.location.state) {

    if (this.props.location.state.segment) {
      segment = this.props.location.state.segment;
    }

    if (this.props.location.state.wallet) {
      wallet = this.props.location.state.wallet;
    }

  }

  this.setState({
    stores: stores,
    filter: {
      ...this.state.filter,
      segment: segment,
      wallet: wallet
    },
    isFilterActive: !!(segment || wallet)
  }, () => {
    this.loadData();
  });

}

  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const { page, pageSize, filter, searchParam } = this.state;

      const res = await this.props.getCustomers(

        (page - 1) * pageSize,
        pageSize,
        filter.status,
        searchParam || filter.name,
        filter.mobileNo,
        filter.emailId,
        filter.city,
        filter.state,
        filter.pincode,
        filter.country,
        filter.membership,
        null,
        null,
        null,
        null,
        filter.segment,
        filter.wallet,
        true,
       this.props.user.user.Role !== "Power User" ? this.props.user.store.key :""
      );

      if (res.code === "0") {

        this.setState({
          list: res.customers || [],
          totalCount: res.totalCount || 0,
          loading: false
        });

      } else {

        this.props.getToastr(
          res.hasOwnProperty("message") && res.message || "Failed to fetch customers"
        );

        this.setState({ loading: false });

      }

    } catch (error) {

      console.error(error);

      this.setState({ loading: false });

      this.props.getToastr("Something went wrong");

    }

  };

  // =====================
  // SEARCH
  // =====================

  onSearch = (text) => {

    this.setState({

      searchParam: text,

      page: 1

    }, this.loadData);

  };

  onRefreshClick = () => {

    this.setState({

      searchParam: "",

      filter: {

        name: "",
        mobileNo: "",
        emailId: "",
        city: "",
        state: "",
        pincode: "",
        country: "",
        membership: "",
        status: "active"

      },

      page: 1,

      isFilterActive: false

    }, this.loadData);

  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize);

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      }, this.loadData);

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      }, this.loadData);

    }

  };

  onFirstClick = () => {

    this.setState({ page: 1 }, this.loadData);

  };

  onLastClick = () => {

    const totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize);

    this.setState({ page: totalPages }, this.loadData);

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({

      pageSize: Number(size),

      page: 1

    }, this.loadData);

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.props.history.push("/home/customer/newcustomer");

    }

    if (btn.Action === "options") {

      this.setState({ showOption: true });

    }

  };

  // =====================
  // FILTER
  // =====================

  onApplyFilter = () => {

    this.setState({

      page: 1,

      showFilter: false,

      isFilterActive: true

    }, this.loadData);

  };

  onClearFilter = () => {

    this.onRefreshClick();

    this.setState({ showFilter: false });

  };

  // =====================
  // ROW BUTTON
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.props.history.push("/home/customer/edit/" + row.key);

    }

    if (btn.Type === "view") {

      this.props.history.push("/home/customer/customerdashboard/" + row.key);

    }

    if (btn.Type === "delete") {

      this.setState({

        showDelete: true,

        selectedRow: row

      });

    }

  };

  deleteRecord = async () => {
    this.setState({ loading: true, showDelete: false });

    await this.props.deleteCustomer(this.state.selectedRow.key);
    this.props.getToastr("Customer deleted successfully");

    // delay 3 seconds
    setTimeout(() => {
      this.setState(
        {
          loading: false,
          selectedRow: null
        },
        this.loadData
      );
    }, 3000);
  };

  // =====================
  // EXPORT
  // =====================

  getExportData = async () => {

    const { filter, searchParam } = this.state;

    const fetchCustomer = async () => {

      try {

        let pitId = "null"; // open new PIT
        let searchAfter = null;
        let allCustomers = [];
        const size = 2000;
        let hasMore = true;

        while (hasMore) {

          const response = await this.props.getCustomers(
            null,
            size,
            filter.status,
            searchParam || filter.name,
            filter.mobileNo,
            filter.emailId,
            filter.city,
            filter.state,
            filter.pincode,
            filter.country,
            filter.membership,
            null,
            true,
            pitId,
            searchAfter,
            filter.segment,
        filter.wallet,
            true,
              this.props.user.user.Role !== "Power User" ? this.props.user.store.key :""

          );

          if (!response || response.code !== "0") break;

          // push customers safely
          if (response.hasOwnProperty("customers") && Array.isArray(response.customers)) {
            allCustomers = allCustomers.concat(response.customers);
            console.log("allCustomers",allCustomers.length);
          }

          // update PIT and search_after safely
          if (response.hasOwnProperty("pitId")) {
            pitId = response.pitId;
          }

          if (response.hasOwnProperty("lastSort") && response.lastSort) {
            searchAfter = JSON.stringify(response.lastSort);
          }

          if (response.hasOwnProperty("hasMore")) {
            hasMore = response.hasMore;
          } else {
            hasMore = false;
          }

        }


    const formattedData = allCustomers.map((c) => {
  let storeName = "";

  if (
    c.hasOwnProperty("StoreID") &&
    this.state.stores &&
    this.state.stores.length
  ) {
    const store = this.state.stores.find(
      (s) =>
        s &&
        s.hasOwnProperty("key") &&
        s.key === c.StoreID
    );

    if (store && store.hasOwnProperty("StoreName")) {
      storeName = store.StoreName;
    }
  }

  return {
    ...c,
    Store: storeName
  };
});

return formattedData;

      } catch (err) {

        this.props.getToastr("Error fetching customer data");
        console.error("Error fetching customer:", err);
        return [];

      }

    };

    const customers = await fetchCustomer();

    if (customers && customers.hasOwnProperty("length")) {
      return customers;
    }

    return [];

  };

  handleExport = async (type) => {

    this.setState({ loading: true });

    const data = await this.getExportData();

    if (!data.length) {

      alert("No data found");

      this.setState({ loading: false });

      return;

    }

const columns = [
  { header: "Customer ID", field: "key", type: "text" },
  { header: "Customer Code", field: "CustomerCode", type: "text" },
  { header: "First Name", field: "FirstName", type: "text" },
  { header: "Last Name", field: "LastName", type: "text" },
  { header: "Gender", field: "Gender", type: "text" },
  { header: "PhoneNo", field: "PhoneNo", type: "text" },
  { header: "EmailID", field: "EmailID", type: "text" },
  { header: "Notes", field: "Notes", type: "text" },
{
  header: "Date of Birth",
  field: "DOBNew",
  formatter: function (value) {
    if (
      value &&
      value.hasOwnProperty("Day") &&
      value.hasOwnProperty("Month") &&
      value.Day !== "" &&
      value.Month !== ""
    ) {
      return (
        value.Day +
        "/" +
        value.Month +
        (value.hasOwnProperty("Year") && value.Year !== ""
          ? "/" + value.Year
          : "")
      );
    }
    return "";
  }
},
{
  header: "Anniversary",
  field: "AnniversaryNew",
  formatter: function (value) {
    if (
      value &&
      value.hasOwnProperty("Day") &&
      value.hasOwnProperty("Month") &&
      value.Day !== "" &&
      value.Month !== ""
    ) {
      return (
        value.Day +
        "/" +
        value.Month +
        (value.hasOwnProperty("Year") && value.Year !== ""
          ? "/" + value.Year
          : "")
      );
    }
    return "";
  }
},

  {
  header: "Address Type",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].AddressType || "" : "";
  }
},
{
  header: "Address Line1",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].Address1 || "" : "";
  }
},
{
  header: "Address Line2",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].Address2 || "" : "";
  }
},
{
  header: "City",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].City || "" : "";
  }
},
{
  header: "State",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].State || "" : "";
  }
},
{
  header: "Postal Code",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].PostalCode || "" : "";
  }
},
{
  header: "Country",
  field: "Addresses",
  formatter: function (value) {
    return value && value.length ? value[0].Country || "" : "";
  }
},

  {
    header: "Membership",
    field: "Membership.Name",
    type: "text"
  },
  {
    header: "MembershipEnrolledBy",
    field: "Membership.MembershipEnrolledBy",
    type: "text"
  },
  {
    header: "MembershipAssignmentDate",
    field: "Membership.AssignmentDate",
    type: "date"
  },

  {
    header: "Opening Balance",
    field: "Membership.OpeningBalance",
    type: "number"
  },

  {
    header: "Outstanding Amount",
    field: "OutStandingAmount",
    type: "number"
  },

  {
    header: "Wallet Balance",
    field: "WalletBalance",
    type: "number"
  },

  {
    header: "Last Recharged Amount",
    field: "WalletLastCreditAmount",
    type: "number"
  },

  {
    header: "Last Visited On",
    field: "LastVisitedOn",
    type: "date"
  },

  {
    header: "Amount Spent",
    field: "AmountSpent",
    type: "number"
  },

  {
    header: "No Of Visits",
    field: "NoOfVisits",
    type: "number"
  },

  { header: "Store", field: "Store", type: "text" },
  { header: "StoreID", field: "StoreID", type: "text" }
];

    await exportFile({

      data,

      columns,

      fileType: type,

      title: "Customers"

    });

    this.setState({ loading: false });

  };

  // =====================
  // IMPORT
  // =====================

  onImport = (type) => {

    this.setState({

      importType: type,

      showImport: true,

      showOption: false

    });

  };

  onImportLog = (type) => {

    this.setState({

      importType: type,

      showImportLog: true,

      showOption: false

    });

  };

  // =====================
  // RENDER
  // =====================
  onPageChange = (page, pageSize) => {
    console.log("page", page);
    this.setState(
      { page, pageSize },
      () => {
        this.loadData();
      }
    );
  };

  render() {

    return (

      <>

        <ListingPage

          {...this.props}
          onPageChange={this.onPageChange}

          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,

              isFilterActive: this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />

        {/* OPTIONS */}

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() =>
              this.setState({
                showFilter: false
              })
            }

            onButtonClick={(action) => {

              if (
                action.toLowerCase() === "apply"
              ) {

                this.onApplyFilter();

              }

              else if (
                action.toLowerCase() === "clear"
              ) {

                this.onClearFilter();

              }

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }

            ]}
          >


            <Input
              type="text"
              label="Customer Name"
              value={this.state.filter.name}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    name: v
                  }
                })
              }
            />

            <Input
              type="number"
              label="Phone No"
              value={this.state.filter.mobileNo}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    mobileNo: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Email"
              value={this.state.filter.emailId}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    emailId: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Category"
              value={this.state.filter.category}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    category: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Membership"
              value={this.state.filter.membership}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    membership: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="City"
              value={this.state.filter.city}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    city: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="state"
              value={this.state.filter.state}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    state: v
                  }
                })
              }
            />

            <Input
              type="number"
              label="Pincode"
              value={this.state.filter.pincode}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    pincode: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Country"
              value={this.state.filter.country}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    countBy: v
                  }
                })
              }
            />

            <Input
              type="select"
              label="Status"
              value={this.state.filter.status}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    status: v
                  }
                })
              }
            >

              <option value="active">
                Active
              </option>

              <option value="inActive">
                Inactive
              </option>

              <option value="all">
                All
              </option>

            </Input>

          </Window>

        )}
        {this.state.showOption && (
          <Window
            header="Options" choiceList
            size="small"
            slide
            onClose={() => this.setState({ showOption: false })}
          >
            {(this.props.user.user.Role === "Power User" ||
              this.props.user.user.Role === "Store Owner") && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap"
                  }}
                >
                  {this.props.user.store &&
                    this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
                    this.props.user.store.NoOfDaysToExpire > 15 && (
                      <ExportButton
                        onExport={this.handleExport}
                        loading={this.state.loading}
                      />
                    )}

                  <Button
                    type="secondary"
                    text="Customer Import"
                    onClick={() => this.onImport("customer")}
                  />

                  <Button
                    type="secondary"
                    text="Customer Import Log"
                    onClick={() => this.onImportLog("customer")}
                  />

                  {this.props.registration &&
                    this.props.registration.registration &&
                    this.props.registration.registration.hasOwnProperty("LoyaltyEnabled") &&
                    this.props.registration.registration.LoyaltyEnabled && (
                      <>
                        <Button
                          type="secondary"
                          text="Customer Loyalty Import"
                          onClick={() => this.onImport("loyaltyCustomer")}
                        />

                        <Button
                          type="secondary"
                          text="Customer Loyalty Import Log"
                          onClick={() => this.onImportLog("loyaltyCustomer")}
                        />
                      </>
                    )}
                </div>
              )}
          </Window>
        )}

        {/* DELETE */}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() => this.setState({ showDelete: false })}

            onButtonClick={(btn) => {

              if (btn === "Yes") this.deleteRecord();

              else this.setState({ showDelete: false });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

        {/* IMPORT */}

        {this.state.showImport && (

          <ImportData

            {...this.props}

            importType={this.state.importType}

            slide

            onClose={() => this.setState({ showImport: false })}

            onImportCompleted={this.loadData}

          />

        )}

        {this.state.showImportLog && (

          <ImportLog

            {...this.props}

            importType={this.state.importType}

            slide

            onClose={() => this.setState({ showImportLog: false })}

          />

        )}

      </>

    );

  }

}

export default CustomerList;